// 状态管理
import Vue from 'vue'
import Vuex from 'vuex'
import router from '../config/router'
import _ from 'underscore'
import clone from 'clone'

import api from '../api/index'
import { menus, generateRoute, handleMenus, fixedMenus } from '../config/menus'

import { LOCAL_STORAGE_KEY } from '../config/constants'

// modules
import dashboard from './modules/dashboard'
import commodity from './modules/commodity'
import recharge from './modules/recharge'
import order from './modules/order'
import supplier from './modules/supplier'
import agent from './modules/agent'
import system from './modules/system'

Vue.use(Vuex)

// states
const state = {
  captcha: '',
  captchaId: '',
  token: '',
  userInfo: null,
  permission: [],
  verify: false,
  isCollapsed: false,
  appBreakpoint: false,
  menus: [],
  errorRouter: [],
  currentPath: ''
}

// getters
const getters = {
  captcha: state => state.captcha,
  captchaId: state => state.captchaId,
  token: state => state.token,
  userInfo: state => state.userInfo,
  verify: state => state.verify,
  isCollapsed: state => state.isCollapsed,
  appBreakpoint: state => state.appBreakpoint,
  showMenu: (state) => {
    const findMenu = (menus) => {
      return _.filter(menus, (item) => {
        if (!item.meta.hide && item.list && item.list.length) {
          item.list = findMenu(item.list)
        }
        return !item.meta.hide
      })
    }
    return findMenu(clone(state.menus))
  },
  breadcrumb: (state) => {
    const breadcrumbs = []
    const group = (menus, path) => {
      return _.find(menus, (item) => {
        if (item.path === path) {
          breadcrumbs.push({
            name: item.meta.label,
            path: ''
          })
          return item.path === path
        }
        if (item.list && item.list.length) {
          let result = group(item.list, path)
          if (result) {
            return breadcrumbs.push({
              name: item.meta.label,
              path: item.path || ''
            })
          }
        }
      })
    }
    group(state.menus, state.currentPath)
    return (breadcrumbs || []).reverse()
  },
  permissionAction: (state) => {
    return (action) => {
      return _.find(state.permission, (item) => {
        return _.indexOf(item.auth.split(','), action) !== -1
      })
    }
  }
}

// mutations
const mutations = {
  updateCaptcha (state, payload) {
    state.captcha = payload
  },
  updateCaptchaId (state, payload) {
    state.captchaId = payload
  },
  updateVerify (state, payload) {
    state.verify = payload
  },
  updateAuth (state, payload) {
    if (payload.token) {
      state.token = payload.token
      localStorage.setItem(LOCAL_STORAGE_KEY, payload.token)
    }
    state.userInfo = {
      account: payload.account || '',
      adminId: payload.adminId || payload.id || '',
      name: payload.name || ''
    }
    state.menus = menus
    payload.menus = payload.menus || fixedMenus
    if (payload.menus && payload.menus.length) {
      const result = handleMenus(payload.menus, state.menus)
      state.menus = result.menus // update menus
      state.permission = result.permission // update permission
    }
    router.addRoutes(generateRoute(state.menus)) // update router
    router.addRoutes(state.errorRouter)
    state.verify = true
  },
  clearAuth (state) {
    state.token = ''
    state.userInfo = null
    state.permission = []
    localStorage.removeItem(LOCAL_STORAGE_KEY)
    api.redirectToLogin()
  },
  updateToken (state, payload) {
    state.token = payload || ''
  },
  updateCollapsed (state, payload) {
    state.isCollapsed = payload
  },
  updateAppBreakpoint (state, payload) {
    state.appBreakpoint = payload
  },
  updateCurrentPath (state, payload) {
    state.currentPath = payload
  },
  updateErrorRouter (state, payload) {
    state.errorRouter = payload
  }
}

// actions
const actions = {
  init ({ commit }) {
    const token = localStorage.getItem(LOCAL_STORAGE_KEY)
    const toLogin = () => {
      commit('updateVerify', true)
      commit('clearAuth')
    }
    if (token) {
      commit('updateToken', token)
      api.login.status().then(res => {
        commit('updateAuth', res.data || {})
      }).catch(() => {
        commit('updateToken', '')
        toLogin()
      })
    } else {
      toLogin()
    }
  },
  captcha ({ commit }) {
    return api.login.captcha({ t: Date.now() }).then((res) => {
      const result = res.data
      commit('updateCaptcha', result.base64)
      commit('updateCaptchaId', result.uuid)
      return res
    }).catch(() => {})
  },
  login ({ commit }, params) {
    return api.login.login(params).then((res) => {
      commit('updateAuth', res.data || {})
      api.redirectToHomepage()
      return res
    })
  },
  logout ({ commit }) {
    commit('clearAuth')
    api.login.logout().catch(() => {})
  }
}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules: {
    dashboard,
    commodity,
    recharge,
    order,
    supplier,
    agent,
    system
  }
})
